import { Box, Button, CircularProgress, Typography, useMediaQuery } from "@mui/material";
import { useTranslation } from "react-i18next";
import AddIcon from '@mui/icons-material/Add';
import { useState } from "react";
import CustomInput from "../../inputs/customInput";
import PostTypeService from "../../../services/postTypeService";
import { useTheme } from "@emotion/react";

const AddPostTypeBox = ({
    handleReload,
    setPopupMsg,
    setPopupType,
    setShowPopup }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const isTablet = useMediaQuery(theme.breakpoints.down('md'));

    const [formValues, setFormValues] = useState({
        name: '',
    });

    const [addErrors, setAddErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormValues((prevValues) => ({
            ...prevValues,
            [name]: value,
        }));
    };

    const validateForm = () => {
        const newAddErrors = {};

        if (!formValues.name) {
            newAddErrors.name = t('nameRequired');
        }

        setAddErrors(newAddErrors);

        return Object.keys(newAddErrors).length === 0;
    };


    const handleSubmit = async (e) => {
        e.preventDefault();

        if (isLoading) return;

        if (validateForm()) {
            try {
                setIsLoading(true);
                const data = await PostTypeService.add(formValues);
                if (data.status === 200) {
                    setPopupMsg(data.data.message);
                    setPopupType('success');
                    setShowPopup(true);
                    handleReload();
                    setFormValues({ name: '' });
                }

                setAddErrors({});
            } catch (error) {
                if (error.response?.status === 400) {
                    const responseErrors = error.response.data || {};
                    const formattedErrors = {};

                    Object.keys(responseErrors).forEach((field) => {
                        formattedErrors[field] = responseErrors[field];
                    });

                    setAddErrors(formattedErrors);
                } else {
                    setPopupMsg(error.response.data.error);
                    setPopupType('error');
                    console.error("An unexpected error occurred:", error);
                    setAddErrors({ general: error.response.data.error });
                }
            } finally {
                setIsLoading(false);
            }
        }
    };



    return (
        <Box
            component="form"
            onSubmit={handleSubmit}
            sx={{
                width: '100%',
                bgcolor: 'background.paper',
                borderRadius: 2,
                border: 1,
                borderColor: theme.palette.customGrey.borderInput,
                p: isTablet ? 2 : 4,
            }}
        >
            <Box sx={{
                display: 'flex',
                justifyContent: 'space-between'
            }}>
                <Typography id="transition-modal-title" variant="h6" component="h2">
                    {t('addPostType')}
                </Typography>
            </Box>
            <CustomInput
                label={t('name')}
                placeholder={t('nameHere')}
                name="name"
                type='text'
                value={formValues.name}
                error={!!addErrors.name}
                helperText={addErrors.name}
                onChange={handleChange}
            />

            {addErrors.general && (
                <Typography align="center" color="error" variant="body2" sx={{ mt: 2 }}>
                    {addErrors.general}
                </Typography>
            )}

            <Box sx={{
                display: 'flex', justifyContent: 'center', alignItems: 'center',
                mt: addErrors.general ? 2 : 4
            }}>
                <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    sx={{ textTransform: 'none', width: 140, height: 40 }}
                >
                    {isLoading ? <CircularProgress color="secondary" size={28} /> :
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <p>{t('add')}</p>
                            <AddIcon fontSize="small" sx={{ mx: 0.4 }} />
                        </Box>
                    }
                </Button>
            </Box>
        </Box>
    );
}

export default AddPostTypeBox;
